import { useMutation } from "@tanstack/react-query";

import { api } from "@/api/client";
import type { KbSearchIn, KbSearchOut } from "@/api/types";

export function useKbSearch(kbId: string) {
  return useMutation({
    mutationFn: (body: KbSearchIn) =>
      api.POST<KbSearchOut>(`/knowledge-bases/${kbId}/search`, body),
  });
}
